import { Box, Button, Divider, Grid } from "@mui/material";
import StyledDialog from "../components/StyledDialog";
import { BaseBox } from "../components/ViewAppointment";
import Flex from "../components/Flex";
import { ReactNode, useContext, useState } from "react";
import CustomTabs from "../components/app/CustomTabs";
import { DisclosureHost } from "../hooks/use-disclosure";
import CustomSelect from "../components/CustomSelect";
import { MediaDevice } from "./video-types";
import { ZoomMediaContext } from "../ZoomMediaProvider";
import officeImage1 from "../assets/OfficeRoom1.jpg";
// import Nature1 from "../assets/Nature1.jpg";
import CustomTitle from "../components/app/CustomTitle";
import Text from "../components/Text";
import AudioVideoStatisticModal from "./video/components/audio-video-statistic";

interface Props {
  disclosureHost: DisclosureHost;
  videoStarted: boolean;
  isMuted: boolean;
  isStartedAudio: boolean;
  selectedBackground: string;
  setSelectedBackground: React.Dispatch<React.SetStateAction<string>>;
  onCameraClick: (image: string) => void;
}

const TabsOptions = [
  {
    value: "devices",
    label: "Devices",
  },
  {
    value: "background",
    label: "Background",
  },
  {
    value: "statistics",
    label: "Statistics",
  },
];
const Settings = ({
  disclosureHost,
  isStartedAudio,
  isMuted,
  videoStarted,
  onCameraClick,
  selectedBackground,
  setSelectedBackground,
}: Props) => {
  const mediaContext = useContext(ZoomMediaContext);

  if (!mediaContext) {
    throw new Error("ZoomMediaContext is not available.");
  }
  const {
    mediaStream,
    activeMicrophone,
    activeSpeaker,
    activeCamera,
    setActiveCamera,
    setActiveMicrophone,
    setActiveSpeaker,
  } = mediaContext;
  const [activeTab, setActiveTab] = useState<string>("devices");
  const [micList] = useState<MediaDevice[]>(mediaStream?.getMicList() ?? []);
  const [speakerList] = useState<MediaDevice[]>(
    mediaStream?.getSpeakerList() ?? []
  );
  const [cameraList] = useState<MediaDevice[]>(
    mediaStream?.getCameraList() ?? []
  );

  async function changeBackgroundImage(i: string) {
    await mediaStream?.updateVirtualBackgroundImage(i, true);
  }

  const ACTIVE_COMP: Record<string, ReactNode> = {
    devices: (
      <Box>
        <Flex
          gap={1.2}
          justifyItems={"center"}
          alignItems={"center"}
          flexDirection={"column"}
        >
          <Box width={"100%"}>
            <CustomSelect
              value={activeCamera}
              clearable={false}
              label="Camera"
              options={cameraList?.map((s) => {
                return {
                  value: s.deviceId,
                  label: s.label,
                };
              })}
              onChange={async (val) => {
                if (val) {
                  if (val !== activeCamera) {
                    await mediaContext?.mediaStream?.switchCamera(val);
                    setActiveCamera(val);
                  }
                }
              }}
            />
          </Box>
          <Box width={"100%"}>
            <CustomSelect
              value={activeMicrophone}
              clearable={false}
              options={micList?.map((s) => {
                return {
                  value: s.deviceId,
                  label: s.label,
                };
              })}
              label="Microphone"
              onChange={async (val) => {
                if (val) {
                  if (val !== activeMicrophone) {
                    await mediaContext?.mediaStream?.switchMicrophone(val);
                    setActiveMicrophone(val);
                  }
                }
              }}
            />
          </Box>
          <Box width={"100%"}>
            <CustomSelect
              value={activeSpeaker}
              clearable={false}
              options={speakerList?.map((s) => {
                return {
                  value: s.deviceId,
                  label: s.label,
                };
              })}
              label="Speaker"
              onChange={async (val) => {
                if (val) {
                  if (val !== activeSpeaker) {
                    await mediaContext?.mediaStream?.switchSpeaker(val);
                    setActiveSpeaker(val);
                  }
                }
              }}
            />
          </Box>
        </Flex>
      </Box>
    ),

    background: (
      <Box>
        {!videoStarted && (
          <Text>
            Your Camera is turned off.Selecting the an Effect Will Turn it on
          </Text>
        )}
        <CustomTitle marginBottom={"10px"}>
          Professional Backgrounds
        </CustomTitle>
        <Grid container spacing={3}>
          {[officeImage1]?.map((i) => (
            <Grid item key={i}>
              <Button
                onClick={() => {
                  setSelectedBackground(selectedBackground === i ? "" : i);
                  changeBackgroundImage(selectedBackground === i ? "" : i);

                  videoStarted ? changeBackgroundImage(i) : onCameraClick(i);
                }}
              >
                <img
                  src={i}
                  height={100}
                  style={{
                    borderRadius: "10px",
                    border: `${
                      selectedBackground === i ? "2px solid blue" : "none"
                    }`,
                  }}
                />
              </Button>
            </Grid>
          ))}
        </Grid>
        {/* <CustomTitle marginBottom={"10px"}>Nature Backgrounds</CustomTitle> */}
        {/* <Grid container spacing={3}>
          {[Nature1, Nature2, Nature3]?.map((i) => (
            <Grid item key={i}>
              <Button
                onClick={() => {
                  setSelectedBackground(i);

                  videoStarted ? changeBackgroundImage(i) : onCameraClick(i);
                }}
              >
                <img
                  src={i}
                  width={100}
                  height={100}
                  style={{
                    borderRadius: "10px",
                    border: `${
                      selectedBackground === i ? "2px solid blue" : "none"
                    }`,
                  }}
                />
              </Button>
            </Grid>
          ))}
        </Grid> */}
      </Box>
    ),
    statistics: (
      <AudioVideoStatisticModal
        isStartedAudio={isStartedAudio}
        isMuted={isMuted}
        isStartedVideo={videoStarted}
      />
    ),
  };

  function handleTabChange(v: string) {
    setActiveTab(v);
  }

  return (
    <StyledDialog
      open={disclosureHost.opened}
      dialogTitle="Settings"
      onClose={disclosureHost.close}
    >
      <Box width={"30vw"}>
        <Divider sx={{ marginY: 1 }} />
        <CustomTabs
          variant="fullWidth"
          style={{
            border: "1px solid #00000029",
          }}
          tabsData={TabsOptions}
          value={activeTab}
          onChange={(data) => handleTabChange(data)}
        />
        <Divider sx={{ marginY: 1 }} />
        <BaseBox>{ACTIVE_COMP[activeTab]}</BaseBox>
      </Box>
    </StyledDialog>
  );
};

export default Settings;
